import * as React from "react";
import Popover from "@material-ui/core/Popover";

type Props = {
  popover: JSX.Element | string;
  children: any;
  externalOpen?: any;
  externalClose?: any;
};

type State = {
  popoverOpen: boolean;
  el: any;
};

export default class BOPopover extends React.Component<Props, State> {
  state = {
    popoverOpen:
      (this.props.externalOpen && this.props.externalOpen.open) || false,
    el: (this.props.externalOpen && this.props.externalOpen.element) || null
  };

  static getDerivedStateFromProps(nextProps: Props, prevState: State) {
    if (
      nextProps.externalOpen &&
      nextProps.externalOpen.open !== prevState.popoverOpen
    ) {
      return {
        popoverOpen: nextProps.externalOpen.open,
        el: nextProps.externalOpen.element
      };
    }

    return null;
  }

  render() {
    const {
      props: { popover, children, externalClose, externalOpen },
      state: { popoverOpen, el }
    } = this;

    return (
      <span
        onMouseEnter={e => {
          if (!popoverOpen && !externalOpen) {
            this.setState({ popoverOpen: true, el: e.currentTarget });
          }
        }}
        onMouseLeave={e => {
          if (!externalOpen) {
            this.setState({ popoverOpen: false });
          }
        }}
      >
        {children}
        <Popover
          style={{ padding: "10px", color: "black" }}
          open={popoverOpen}
          anchorEl={el}
          anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          transformOrigin={{ horizontal: "left", vertical: "top" }}
          onClose={externalClose || null}
        >
          {popover}
        </Popover>
      </span>
    );
  }
}
